import { RhoV2Config, RhoV2ConfigParams } from './typings'
import {
  DefaultCustomConfig,
  DefaultMainnetConfig,
  DefaultTestnetConfig
} from './config'
import { RhoV2API } from './api'
import { RhoV2AuthAPI } from './api/auth'
export * from './typings'

class RhoV2SDK {
  config: RhoV2Config
  api: RhoV2API
  auth: RhoV2AuthAPI

  constructor(configParams: RhoV2ConfigParams = {}) {
    this.config = this.parseConfig(configParams)
    this.api = new RhoV2API(this.config)
    this.auth = new RhoV2AuthAPI(this.config)
  }

  private parseConfig(config: RhoV2ConfigParams) {
    let baseConfig = {}

    if(config.network === 'mainnet') {
      baseConfig = DefaultMainnetConfig
    } else if(config.network === 'testnet') {
      baseConfig = DefaultTestnetConfig
    } else if(config.network === 'custom') {
      baseConfig = DefaultCustomConfig
    } else {
      throw new Error('Unknown network config')
    }

    return {
      ...baseConfig,
      ...config,
    } as RhoV2Config
  }
}

export { RhoV2SDK }
